import {Rate} from "antd";
import styled from "styled-components";

/** Even horizontal spacing between stars in the subscription “Your review” block. */
export const SubscriptionDrawerDisplayRate = styled(Rate)`
  &&.ant-rate {
    display: inline-flex !important;
    align-items: center;
    flex-wrap: nowrap;
    column-gap: 16px;
    font-size: 22px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  &&.ant-rate > .ant-rate-star {
    margin: 0 !important;
    padding: 0 !important;
  }
`;
